export default __webpack_public_path__ + "static/media/facility.eb5f28d4.png";